import { render } from "./PageNotFound.vue?vue&type=template&id=4123f014&scoped=true"
const script = {}

import "./PageNotFound.vue?vue&type=style&index=0&id=4123f014&scoped=true&lang=css"

import exportComponent from "/builds/proximis/page_abonnement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4123f014"]])

export default __exports__